import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { PolarAreaChart } from "components/charts";
import BarChartBorderRadius from "components/charts/BarChartBorderRadius";

const CategoriesBarChart = ({
  chartClass = "chart-container",
  title,
  data,
}) => {
  console.log("CategoriesBarChart data", data);
  return (
    <Card>
      <CardBody>
        <CardTitle>{title}</CardTitle>
        <div className={"mb-5"}>
          <BarChartBorderRadius data={data.chartData} />
        </div>
      </CardBody>
    </Card>
  );
};

export default CategoriesBarChart;
